<template>
<v-container fluid class="pa-0">
<v-layout row wrap class="ma-0 mt-2" v-if="!loading.fetchData">
    <v-row no-gutters row wrap class="ma-0 mt-2 quiz-v-card" v-if="quizItemTree.length > 0">
        <template v-for="(quizTitle) in quizItemTree">
            <template v-for="(quizItem) in quizTitle.children">
            <v-col cols="12" v-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'VARCHAR'" class="" :key="quizItem.qiz_id">
                <v-text-field :title="quizItem.qiz_id" :label="quizItem.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value"></v-text-field>
            </v-col>
            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'INT'" class="" :key="quizItem.qiz_id">
                <v-text-field :title="quizItem.qiz_id" :label="quizItem.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" type="number"></v-text-field>
            </v-col>
            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'RADIO'" class="" :key="quizItem.qiz_id">
                <v-radio-group v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" >
                    <v-radio v-for="(radio) in quizItem.children" :key="radio.qiz_id" :label="radio.qiz_name" :value="radio.qiz_id">
                    <template v-slot:label v-if="typeListById[radio.qiz_typ_id_field].typ_name == 'VARCHAR'">
                        <v-text-field :title="radio.qiz_id" :label="radio.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value"></v-text-field>
                    </template>
                    </v-radio>
                    <!--
                    -->
                </v-radio-group>
            </v-col>
            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'DATE'" class="pr-2 pl-2" :key="quizItem.qiz_id">
                <DatePicker :label="quizItem.ctp_label" :objectForm="taskItem._pivot['quiz'][quizItem.qiz_id]" fieldName='tqz_txt_value'></DatePicker>
            </v-col>
            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'BOOL'" class="pr-2 pl-2" :key="quizItem.qiz_id">
                <v-checkbox :title="quizItem.qiz_id" :label="quizItem.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" ></v-checkbox>
            </v-col>
            <!--
            <v-flex v-else-if="(item.ctp_typ_id_section == itemType.typ_id) && item.ctp_data_type == 'BOOL'" xs12 class="pr-2 pl-2" :key="index">
                <v-checkbox :title="item.ctp_id" :label="item.ctp_label" v-model="item.cdd_value" ></v-checkbox>
            </v-flex>
            <v-flex v-else-if="(item.ctp_typ_id_section == itemType.typ_id) && item.ctp_data_type == 'LIST'" xs12 class="pr-2 pl-2" :key="index">
                <v-select :title="item.ctp_id" style="z-index: 2000;"
                    :items="listsData[item.ctp_lst_id]" item-value="lsd_id" item-text="lsd_label"
                    v-model="item.cdd_lsd_id" :label="item.ctp_label" @change="listChange(item, index); calculComputed(item, index);">
                </v-select>
            </v-flex>
            <v-flex v-else-if="(item.ctp_typ_id_section == itemType.typ_id) && item.ctp_data_type == 'PERCENT'" xs12 class="pr-2 pl-2" :key="index">
                <v-text-field :title="item.ctp_id" :label="item.ctp_label" v-model="item.cdd_value" ></v-text-field>
            </v-flex>
            <v-flex v-else-if="(item.ctp_typ_id_section == itemType.typ_id) && item.ctp_data_type == 'DATE'" xs12 class="pr-2 pl-2" :key="index">
                <DatePicker :label="item.ctp_label" :objectForm="item" fieldName='cdd_value'></DatePicker>
            </v-flex>
            <v-flex v-else-if="(item.ctp_typ_id_section == itemType.typ_id) && item.ctp_data_type == 'FLOAT'" xs12 class="pr-2 pl-2" :key="index">
                <v-text-field :title="item.ctp_id" :label="item.ctp_label" v-model="item.cdd_value" type="number" @change="calculComputed(item, index)"></v-text-field>
            </v-flex>
            -->
            </template>
        </template>
    </v-row>
</v-layout>
</v-container>
</template>


<script>
import DatePicker from '@/components/ui/DatePicker'
//import AutocompleteMulti from '@/components/ui/AutocompleteMulti'

import { mapState, mapWritableState, mapActions } from 'pinia'
import { useQuizStore } from '@/stores/quiz'
import { useTypeStore } from '@/stores/type'
import { useTaskStore } from '@/stores/task'

export default {
    name: 'task-quiz-edit',
    props: [ 'quiz', 'task' ],
    components: {
        DatePicker
    },
    computed: {
        ...mapState(useQuizStore, {quizItemList: 'itemList', quizItemTree: 'itemTree' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapWritableState(useTaskStore, {taskItem: 'item' }),
    },
    data: function () {
        return {
            loading : { fetchData: true },         // Enregistrement en cours...
            typPanel: 0,
            radioGroup: null,
            formValues: {}
        }
    },
    async mounted (){
        let params = '' //(this.task.tsk_id) ? '&tqz_tsk_id=' + this.task.tsk_id : ''
        await this.quizFetchItems('?per_page=false&qiz_typ_id=QIZ01' + params)
        this.quizItemList.forEach(elem => {
            if( !this.taskItem._pivot['quiz'][elem.qiz_id] ){
                this.taskItem._pivot['quiz'][elem.qiz_id] = { tqz_tsk_id: this.task.tsk_id, tqz_qiz_id: elem.qiz_id, tqz_num_value: 0, tqz_txt_value: null }
            }
          //this.formValues[elem.qiz_id] = { tqz_tsk_id: this.task.tsk_id, tqz_qiz_id: elem.qiz_id, tqz_num_value: null, tqz_txt_value: null }
        })

        this.loading.fetchData = false

    },
    methods: {
        ...mapActions(useQuizStore, { quizFetchItems: 'fetchItems'}),

    }
}
</script>

<style>
.quiz-v-card > div {
  border: solid 1px #2daee5 !important;
  border-radius: 24px !important;
  padding: 4px !important;
  margin-bottom: 8px !important;
}
</style>